module.exports = "/_next/static/images/CustomerStoryToggle-aaf1cf7401912d62276adb5a1618bb1c.png";